import { Button, Card, Loader, SimpleGrid, ThemeIcon } from '@mantine/core';
import { IconFile, IconFileText, IconMovie, IconPhoto, IconZip } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import humanizeFileSize from 'src/Utils/humanizeFileSize';

import styles from './ExportedFileList.module.scss';
import { Props } from './ExportedFileList.types';

const getFileIcon = (mimeType?: string) => {
  if (!mimeType) return <IconFile size="2.5rem" />;
  if (mimeType.startsWith('image/')) return <IconPhoto size="2.5rem" />;
  if (mimeType.startsWith('video/')) return <IconMovie size="2.5rem" />;
  if (mimeType.startsWith('application/zip')) return <IconZip size="2.5rem" />;
  if (mimeType.startsWith('text/')) return <IconFileText size="2.5rem" />;
  return <IconFile size="2.5rem" />;
};

const ExportedFileList = ({ files, loading }: Props) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className={styles.centered}>
        <Loader />
      </div>
    );
  }

  if (!files || files.length === 0) {
    return (
      <div className={styles.centered}>
        <div>{t('exportFiles.noFiles', 'Aucun fichier dans cet export.')}</div>
      </div>
    );
  }

  const downloadFile = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <SimpleGrid cols={{ base: 2, sm: 3, md: 4, lg: 5 }} spacing="lg" verticalSpacing="lg">
      {files.map(file => (
        <Card
          key={file.id}
          shadow="sm"
          padding="lg"
          radius="md"
          withBorder
          className={styles.fileCard}
        >
          <Card.Section className={styles.iconSection}>
            <ThemeIcon size={80} radius={80} variant="light">
              {getFileIcon(file.mimeType)}
            </ThemeIcon>
          </Card.Section>

          <div className={styles.fileName}>{file.name}</div>
          <div className={styles.fileSize}>{humanizeFileSize(file.size ?? 0)}</div>

          <Button
            variant="light"
            color="blue"
            fullWidth
            mt="md"
            radius="md"
            onClick={() => downloadFile(file.urls?.fileUrl ?? '')}
            disabled={!file.urls?.fileUrl}
          >
            {t('exportFiles.download', 'Télécharger')}
          </Button>
        </Card>
      ))}
    </SimpleGrid>
  );
};

export default ExportedFileList;
